function stickyATCScrollDebounce(method, delay) {
	clearTimeout(method._tId);
	method._tId = setTimeout(function() {
		method();
	}, delay);
}

function adjustMobileStickyATC(status) {
	var stickyLeftSide = document.querySelector("#mobile-sticky-atc .mobile-sticky-atc__options-container");
	var stickyATC = document.querySelector("#mobile-sticky-atc");
	var stickyLeftSideChildren = stickyLeftSide.children;
	var combinedHeight = parseFloat(window.getComputedStyle(stickyATC).paddingTop) + 30;

	// console.log("combinedHeight: ", combinedHeight)
	for (var i = 0; i < stickyLeftSideChildren.length; i++) {
		var child = stickyLeftSideChildren[i];
		var styles = window.getComputedStyle(child);
		var margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
		combinedHeight += child.offsetHeight + margin;
	};
}

function stickyATCHandleScroll() {
	var stickyATC = document.getElementById("mobile-sticky-atc");
	var staticATC = document.querySelector(".main-product__atc-container #atc-cta");
	if(document.querySelector("body.template-page-hype-erg") && document.querySelector(".pdp-features-container")){
		staticATC = document.querySelector(".pdp-features-container");
	}
	var fcBadge = document.querySelector("#fc_frame");
	var harkBadge = document.querySelector("#hark-floating-icon-button-hark");
	var attentiveCreative = document.querySelector("#attentive_creative");

	if (staticATC && stickyATC && !window.Branch.functions.isElementVisibleOrBelow(".main-product__atc-container #atc-cta")) {
		setTimeout(function(){
			stickyATC.classList.add("mobile-sticky-atc--show");
			stickyATC.classList.add("mobile-sticky-atc--grow");
			let stickyATCOffsetHeight = stickyATC.offsetHeight;
			// if(hypePage){
			// 	stickyATCOffsetHeight = 0 - stickyATC.offsetHeight;
			// }
			if(window.innerWidth <= 1168){
				stickyATC.style.transform = `translateY(0)`;
			} else {
				stickyATC.style.transform = `translateY(${stickyATCOffsetHeight - 1}px)`;
			}
		}, 10)

		adjustMobileStickyATC("show");
		if (fcBadge) {
			fcBadge.style.marginBottom = window.innerWidth <= 1168 ? "80px" : "0px";
			fcBadge.style.transition = "all .5s ease-in";
		}
		if (harkBadge) {
			harkBadge.style.marginBottom = window.innerWidth <= 1168 ? "80px" : "0px";
			harkBadge.style.transition = "all .5s ease-in";
		}
		if (attentiveCreative) {
			attentiveCreative.style.marginBottom = window.innerWidth <= 1168 ? "80px" : "0px";
			attentiveCreative.style.transition = "all .5s ease-in";
		}
	}
	if (staticATC && stickyATC && window.Branch.functions.isElementVisibleOrBelow('.main-product__atc-container')) {
		stickyATC.classList.remove("mobile-sticky-atc--show");
		let stickyATCOffsetHeight = stickyATC.offsetHeight;
		if(hypePage){
			stickyATCOffsetHeight = 0 - stickyATC.offsetHeight;
		}
		if(window.innerWidth <= 1168){
			stickyATC.style.transform = `translateY(-${stickyATCOffsetHeight}px)`;
		} else {
			stickyATC.style.transform = `translateY(0px)`;
		}

		setTimeout(function(){
			stickyATC.classList.remove("mobile-sticky-atc--grow");
		}, 250)
		
		adjustMobileStickyATC("remove");
		if (fcBadge) {
			fcBadge.style.marginBottom = 0;
		}
		if (harkBadge) {
			harkBadge.style.marginBottom = 0;
		}
		if (attentiveCreative) {
			attentiveCreative.style.marginBottom = 0;
		}
	}
}

let noHypePage = true;
if(typeof hypePage != "undefined" && typeof hypePage != "null" && hypePage == true){
	noHypePage = false;
}

if(noHypePage == true){
	document.addEventListener("scroll", (event) => {
		stickyATCScrollDebounce(stickyATCHandleScroll, 200);
	}, {
		passive: true
	});
}

